import { Box, Flex, HStack } from '@cdl/heartbeat-react';
import { forwardRef } from 'react';
import logo from '../../../assets/images/logo.svg';
import { Logout } from '../../auth/components/Logout';
import { BurgerNav } from './BurgerNav';
import { useSelector } from 'react-redux';
import { isAdminSelector } from '../../auth/selectors/auth.selectors';

interface Props {
  height: string;
}

export const Header = forwardRef<HTMLDivElement, Props>(({ height }, ref) => {
  const isAdmin = useSelector(isAdminSelector);

  return (
    <HStack
      alignItems='center'
      borderBottom='1px solid'
      borderColor='neutral.100'
      bgColor='neutral.0'
      position='fixed'
      height={height}
      width='100%'
      zIndex='1'
      px='m'
    >
      {isAdmin && <BurgerNav />}
      <Flex flex='1' align='center' ref={ref}>
        <Box display='flex' alignItems='center' mx='l'>
          <img src={logo} alt='Platane_logo' style={{ height: '1.25rem' }} />
        </Box>
      </Flex>
      <Logout />
    </HStack>
  );
});
